import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { QuantityStepperV2 } from '../../../QuantityStepperV2';
import { BodyText } from '../../../Text';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientListItemQuantityStepper = memo((props: Props) => {
  const {
    increaseButtonAccessibilityLabel,
    decreaseButtonAccessibilityLabel,
    isDisabled,
    quantity,
    onIncrease,
    onDecrease,
  } = props;

  return (
    <QuantityStepperV2.Container style={styles.container}>
      <QuantityStepperV2.DecreaseButton
        accessibilityLabel={decreaseButtonAccessibilityLabel}
        palette="kale/008"
        onPress={onDecrease}
        isDisabled={isDisabled || quantity === 0}
      />

      <View style={styles.quantityContainer}>
        <BodyText sizeMatch={['22']} maxFontSizeMultiplier={1}>
          {quantity}
        </BodyText>
      </View>

      <QuantityStepperV2.IncreaseButton
        accessibilityLabel={increaseButtonAccessibilityLabel}
        palette="kale/008"
        onPress={onIncrease}
        isDisabled={isDisabled}
      />
    </QuantityStepperV2.Container>
  );
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing['2'],
  },
  quantityContainer: {
    minWidth: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  onIncrease: () => void;
  onDecrease: () => void;
  quantity: number;
  isDisabled: boolean;
  increaseButtonAccessibilityLabel: string;
  decreaseButtonAccessibilityLabel: string;
};
